import { ICameraCCTV, ICameraCCTVPreset } from '@api/models';
import { PtzControlsPayload } from '@api/types/ptz-controls-payload.type';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export interface CctvChannelPayload {
    number: string;
    hlsUrl?: string;
    webrtcUrl?: string;
    folder: string;
    ptzControl: {
        isAvailable: boolean;
        deviceId?: string;
    };
}

export interface IPanPayload {
    pan: number;
    channelNumber: string;
}
export interface ITiltPayload {
    tilt: number;
    channelNumber: string;
}
export interface IZoomPayload {
    zoom: number;
    channelNumber: string;
}

export const createCctvCameraChannel = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    payload: CctvChannelPayload
) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/channels`,
        payload
    );
    return data as ICameraCCTV;
};

export const updateCctvCameraChannel = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    channelId: string,
    payload: CctvChannelPayload
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/channels/${channelId}`,
        payload
    );
    return data as ICameraCCTV;
};

export const deleteLiveUnitChannel = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    channelId: string
) => {
    await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/channels/${channelId}`
    );
};

export const getAllCctvCameras = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/camera-cctvs`);
    return data as ICameraCCTV[];
};

export const getCctvCameraById = async (cctvCameraId: string) => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/camera-cctvs/${cctvCameraId}`
    );
    return data as ICameraCCTV;
};

export const getAllCctvCamerasOfProject = async (clientId: string, projectId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs`
    );
    return data as ICameraCCTV[];
};

export const getCctvCameraOfProjectById = async (clientId: string, projectId: string, cctvCameraId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}`
    );
    return data as ICameraCCTV;
};

export const createCctvCamera = async (clientId: string, projectId: string, payload: any) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs`,
        payload
    );
    return data as ICameraCCTV;
};

export const updateCctvCamera = async (clientId: string, projectId: string, cameraId: string, payload: any) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cameraId}`,
        payload
    );
    return data as ICameraCCTV;
};

export const moveProjectOfCctvCamera = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/update-project`,
        {
            newProjectId: payload,
        }
    );
    return data as ICameraCCTV;
};

export const updatePtzCameraControl = async (projectId: string, cameraId: string, payload: PtzControlsPayload) => {
    await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/projects/${projectId}/camera-cctvs/${cameraId}/ptz`,
        payload
    );
    // (`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}/ptz`, payload)
};

export const updatePtzPan = async (clientId: string, projectId: string, cctvCameraId: string, payload: IPanPayload) =>
    await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/pan`,

        payload
    );

export const updatePtzTilt = async (clientId: string, projectId: string, cctvCameraId: string, payload: ITiltPayload) =>
    await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/tilt`,

        payload
    );

export const updatePtzZoom = async (clientId: string, projectId: string, cctvCameraId: string, payload: IZoomPayload) =>
    await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/zoom`,

        payload
    );

export const getAllPresetOfChannel = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    channelNumber: string
) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/presets?channelNumber=${channelNumber}`
    );
    return data as ICameraCCTVPreset[];
};

export const createPtzHomePreset = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    payload: { channelNumber: string }
) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/presets/home`,
        payload
    );
    return data as ICameraCCTVPreset[];
};

export const createPtzPreset = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    payload: { presetName: string; channelNumber: string }
) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/presets`,
        payload
    );
    return data as ICameraCCTVPreset[]; // or just `return data;` if you don’t care about type here
};

export const applyPtzPreset = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,
    channelNumber: string,
    presetId: string
) => {
    await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/presets/${presetId}/goto`,

        {
            channelNumber: channelNumber,
        }
    );
};

export const deletePtzPreset = async (
    clientId: string,
    projectId: string,
    cctvCameraId: string,

    presetId: string
) => {
    await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cctvCameraId}/ptz/presets/${presetId}`
    );
};

export const getStreamToken = async (clientId: string, projectId: string, cameraId: string) => {
    const { data } = await http.post<{ token: string }>(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/camera-cctvs/${cameraId}/stream-tokens`,
        {}
    );
    return data.token;
};
